import { IndicatorStats } from '@/modules/calendar/model/forecast-game/forecast-game-state';

export const MIN_RESOLVED = 5;
export const MIN_WIN_RATE = 0.6;

export interface Specialist {
  dataSeriesId: number;
  display: string;
  winRate: number;
}

/** Pure: indicators where you've resolved enough forecasts to have a real edge over MNI. */
export function computeSpecialists(byIndicator: Record<number, IndicatorStats>): Specialist[] {
  return Object.entries(byIndicator)
    .map(([id, stats]) => {
      const resolved = stats.wins + stats.losses + stats.ties;
      const winRate = resolved > 0 ? stats.wins / resolved : 0;
      return { dataSeriesId: Number(id), display: stats.display, winRate, resolved };
    })
    .filter(s => s.resolved >= MIN_RESOLVED && s.winRate >= MIN_WIN_RATE)
    .sort((a, b) => b.winRate - a.winRate)
    .map(({ dataSeriesId, display, winRate }) => ({ dataSeriesId, display, winRate }));
}
